import React from 'react';
import PropTypes from 'prop-types';
import { Button, Drawer, DrawerHeader, DrawerContent, DrawerFooter } from '@sainsburys-tech/bolt';
import { ArgosLogo, HabitatLogo } from '@sainsburys-tech/bolt-icons';
import * as Styled from './FulfilledByArgos.styles';

var handleButtonClick = function handleButtonClick() {
  window.location.href = "/help/part-of-the-family";
};

var FulfilledByArgos = function FulfilledByArgos(_ref) {
  var heading = _ref.heading,
      show = _ref.show,
      position = _ref.position,
      toggle = _ref.toggle,
      dataTest = _ref['data-test'];
  return /*#__PURE__*/React.createElement(Drawer, {
    position: position,
    show: show,
    onClose: toggle,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(DrawerHeader, null, heading), /*#__PURE__*/React.createElement(DrawerContent, null, /*#__PURE__*/React.createElement(Styled.LogoHeader, null, /*#__PURE__*/React.createElement(HabitatLogo, {
    width: "100px",
    height: "38px"
  }), " ", /*#__PURE__*/React.createElement(ArgosLogo, {
    width: "45px",
    height: "38px"
  })), /*#__PURE__*/React.createElement(Styled.ContentBody, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "What does fulfilled and delivered by Argos mean?"), /*#__PURE__*/React.createElement("p", null, "It means that when you shop on Habitat.co.uk:"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Argos will take payment"), /*#__PURE__*/React.createElement("li", null, "You can collect from any Argos store "), /*#__PURE__*/React.createElement("li", null, "Argos will deliver your order "), /*#__PURE__*/React.createElement("li", null, "You get one account to manage your Argos and Habitat orders"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Got questions?"), /*#__PURE__*/React.createElement("p", null, "You can find more information about what this means for delivery, collection and your account in help."), /*#__PURE__*/React.createElement("a", {
    href: "/help",
    "data-test": "".concat(dataTest, "-got-questions-link")
  }, "Go to help")))), /*#__PURE__*/React.createElement(DrawerFooter, null, /*#__PURE__*/React.createElement(Button, {
    as: "a",
    full: true,
    onClick: handleButtonClick,
    "data-test": "".concat(dataTest, "-button")
  }, "Read more on Habitat & Argos")));
};

FulfilledByArgos.displayName = 'FulfilledByArgos';
FulfilledByArgos.defaultProps = {
  show: false,
  position: 'right',
  heading: 'Habitat and Argos',
  toggle:
  /* istanbul ignore next */
  function toggle() {},
  'data-test': 'component-fulfilled-by-argos'
};
FulfilledByArgos.propTypes = {
  /**
   * Prop toggle the visibility of the quick view
   */
  show: PropTypes.bool,

  /**
   * Prop to set the position of the quick view
   */
  position: PropTypes.oneOf(['left', 'right', 'center']),

  /**
   * Prop to set the title of the quick view
   */
  heading: PropTypes.string,

  /**
   * Prop for callbacks if needed on closing or changing product id
   */
  toggle: PropTypes.func,

  /**
   * Prop for setting data-test attribute for testing
   */
  'data-test': PropTypes.string
};
export default FulfilledByArgos;